// Hostname constants
export const CONSOLE_HOSTNAME = 'console.bytebeam.io'
export const CLOUD_HOSTNAME = 'app.bytebeam.io'
export const LOCAL_HOSTNAME = 'localhost'

export enum DeploymentType {
	CONSOLE = 'console',
	CLOUD = 'cloud',
	ENTERPRISE = 'enterprise', // Any other domain (custom domains)
	LOCAL = 'local', // localhost in development
}

let _cachedDeploymentType: DeploymentType | null = null

export function getDeploymentType(): DeploymentType {
	if (_cachedDeploymentType !== null) {
		return _cachedDeploymentType
	}

	const hostname = window.location.hostname

	let result: DeploymentType
	if (hostname === CONSOLE_HOSTNAME) {
		result = DeploymentType.CONSOLE
	} else if (hostname === CLOUD_HOSTNAME) {
		result = DeploymentType.CLOUD
	} else if (hostname === LOCAL_HOSTNAME) {
		result = DeploymentType.LOCAL
	} else {
		result = DeploymentType.ENTERPRISE
	}

	_cachedDeploymentType = result
	return result
}

export function getConsoleUrl(): string {
	return `https://${CONSOLE_HOSTNAME}`
}

export function isConsoleDeployment(): boolean {
	const deploymentType = getDeploymentType()
	return deploymentType === DeploymentType.CONSOLE
}

export function isPlatformDeployment(): boolean {
	const deploymentType = getDeploymentType()
	return (
		deploymentType === DeploymentType.CLOUD ||
		deploymentType === DeploymentType.ENTERPRISE ||
		deploymentType === DeploymentType.LOCAL
	)
}

export function isCloudDeployment(): boolean {
	return getDeploymentType() === DeploymentType.CLOUD
}
